import { SVGProps } from 'react'

export const NetworksIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 17V16.8C3.5 15.1198 3.5 14.2798 3.82698 13.638C4.1146 13.0735 4.57354 12.6146 5.13803 12.327C5.77976 12 6.61984 12 8.3 12H14.7C16.3802 12 17.2202 12 17.862 12.327C18.4265 12.6146 18.8854 13.0735 19.173 13.638C19.5 14.2798 19.5 15.1198 19.5 16.8V17M3.5 17C2.39543 17 1.5 17.8954 1.5 19C1.5 20.1046 2.39543 21 3.5 21C4.60457 21 5.5 20.1046 5.5 19C5.5 17.8954 4.60457 17 3.5 17ZM19.5 17C18.3954 17 17.5 17.8954 17.5 19C17.5 20.1046 18.3954 21 19.5 21C20.6046 21 21.5 20.1046 21.5 19C21.5 17.8954 20.6046 17 19.5 17ZM11.5 17C10.3954 17 9.5 17.8954 9.5 19C9.5 20.1046 10.3954 21 11.5 21C12.6046 21 13.5 20.1046 13.5 19C13.5 17.8954 12.6046 17 11.5 17ZM11.5 17V7M5.5 7H17.5C18.4319 7 18.8978 7 19.2654 6.84776C19.7554 6.64477 20.1448 6.25542 20.3478 5.76537C20.5 5.39782 20.5 4.93188 20.5 4C20.5 3.06812 20.5 2.60218 20.3478 2.23463C20.1448 1.74458 19.7554 1.35523 19.2654 1.15224C18.8978 1 18.4319 1 17.5 1H5.5C4.56812 1 4.10218 1 3.73463 1.15224C3.24458 1.35523 2.85523 1.74458 2.65224 2.23463C2.5 2.60218 2.5 3.06812 2.5 4C2.5 4.93188 2.5 5.39782 2.65224 5.76537C2.85523 6.25542 3.24458 6.64477 3.73463 6.84776C4.10218 7 4.56812 7 5.5 7Z"
      stroke="#475467"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
